<template>
    <div>
        <input
            :id="checkboxId"
            :checked="checkboxChecked"
            class="custom-control-input"
            :disabled="!isAdmin"
            :name="checkboxId"
            type="checkbox"
            @change="handleCheckboxChange"
        />
        <label
            class="custom-control-label disable-text-select"
            :for="checkboxId"
            style="display: inline"
        >
            <slot name="label"></slot>
        </label>
        <input
            v-model="inputValue"
            class="reminder-text-input mr-1"
            :disabled="!isAdmin || inputDisabled"
            :maxlength="maxLength"
            :name="inputName"
            style="width: 148px"
            type="text"
        />
        <slot name="afterInput"></slot>
        <slot name="tooltip"></slot>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = withDefaults(
    defineProps<{
        checkboxId: string;
        inputName: string;
        inputValue?: string;
        inputDefaultValue?: string;
        checkboxChecked: boolean;
        isAdmin: boolean;
        maxLength?: number;
    }>(),
    {
        inputValue: '',
        inputDefaultValue: '',
        maxLength: undefined,
    },
);

const inputValue = ref(props.checkboxChecked ? (props.inputValue ?? props.inputDefaultValue ?? '') : null);
const inputDisabled = ref(!props.checkboxChecked);
const previousInputValue = ref(inputValue.value);

// Watch for changes in checkboxChecked
watch(
    () => props.checkboxChecked,
    newVal => {
        if (!newVal) {
            inputValue.value = null;
            inputDisabled.value = true;
        } else {
            inputValue.value = previousInputValue.value ?? props.inputDefaultValue ?? '';
            inputDisabled.value = false;
        }
    },
);

// Handle checkbox state changes
function handleCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (!isChecked) {
        previousInputValue.value = inputValue.value;
        inputValue.value = null;
        inputDisabled.value = true;
    } else {
        inputValue.value = previousInputValue.value ?? props.inputDefaultValue ?? '';
        inputDisabled.value = false;
    }
}
</script>
